import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import Tabs, { Tab } from "material-ui/Tabs";
import Switch from "material-ui/Switch";
import Grid from "material-ui/Grid";
import Radio, { RadioGroup } from "material-ui/Radio";
import List, { ListItem, ListItemText } from "material-ui/List";
import { toast } from "react-toastify";
import Tooltip from "material-ui/Tooltip";

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel
} from "material-ui/Form";
import { withStyles } from "material-ui/styles"; 
import styles from "./styles";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

import { validateFormData } from "../../../common/formtool";

import generateNames from "../../../common/namegenerate";

import { CUSTOM_METADATA_STANDARD } from "../../../common/constants";

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#5a5a5a",
    color: "white",
    maxWidth: "auto",
    fontSize: theme.typography.pxToRem(15),
    border: "1px solid #dadde9"
  }
}))(Tooltip);

class CreateFiberTest extends React.Component {
  constructor(props) {
    super(props);
    const { job, userPreference } = props;
    this.state = {
      open: true,
      boolValue: [
        {
          id: true,
          name: "Yes"
        },
        {
          id: false,
          name: "No"
        }
      ],
      allowEditMaxLength: true,
      allowApplyLength: true,
      errors: {},
      tabs:
        job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)
          ? [
              props.translate("test_details"),
              props.translate("fiber_test_cable_type"),
              props.translate("test_budget_loss"),
              props.translate("test_settings"),
              props.translate("test_metadata")
            ]
          : [
              props.translate("test_details"),
              props.translate("fiber_test_cable_type"),
              props.translate("test_budget_loss"),
              props.translate("test_settings")
            ],
      tabPosition: 0,
      testPrefixType: "custom",
      test: {
        jobid: job.id,
        prefix: "",
        startvalue: "01",
        endvalue: "24",
        names: null,
        floor: "",
        telecommunicationspace: "",
        panel: "",
        // "cablestandard": '',
        // "linkmodel": '',
        // "cabletype":'',

        cablebrand: "",
        cabletype: "",
        cablepart: "",
        refractiveindex: 1.49,
        limitmethodtype: "",

        group: "",
        standard: "",
        adapterscount: 2,
        splicecount: 0,
        illosswllow: 0,
        illosswlhigh: 0,

        application: "",

        limitwavelength: "",

        cordlosstype: { id: 1 },
        adapterloss: 0.75,
        spliceloss: 0.3,
        measurelength: false,
        callimitlength: false,
        maxlength: 1000,

        testmode: "",
        direction: "",
        referencemethod: "",
        flux: false,
        connectortype: "",

        // "connectorbrandnear": '',
        // "connectorbrandfar": '',
        // "cableshielding": '',
        metadata: [
          {
            level: "1",
            value: "",
            field: job.level1,
            default: job.level1 !== "",
            enabled: job.level1 !== ""
          },
          {
            level: "2",
            value: "",
            field: job.level2,
            default: job.level2 !== "",
            enabled: job.level2 !== ""
          },
          {
            level: "3",
            value: "",
            field: job.level3,
            default: job.level3 !== "",
            enabled: job.level3 !== ""
          },
          {
            level: "4",
            value: "",
            field: job.level4,
            default: job.level4 !== "",
            enabled: job.level4 !== ""
          },
          {
            level: "5",
            value: "",
            field: job.level5,
            default: job.level5 !== "",
            enabled: job.level5 !== ""
          },
          {
            level: "6",
            value: "",
            field: job.level6,
            default: job.level6 !== "",
            enabled: job.level6 !== ""
          }
        ]
      },
      disabledToogleIdentifier: false,
      cablebrands: [],
      cabletypes: [],
      cableparts: [],
      appDetails: [],
      stdDetails: [],
      disbleBudgetLossMin: false,
      disbleBudgetLossMax: false,
      disableRefractiveIndex: true,
      testIDType: "sequential",
      lantekfiles: null,
      modalRef: React.createRef()
    };
    this.budgetLossMin = "850nm";
    this.budgetLossMax = "1300nm";
    this.cableType = "";
    this.checkForAlreadySelectedSubtests = this.checkForAlreadySelectedSubtests.bind(
      this
    );
    this.handleImport = this.handleImport.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  checkForAlreadySelectedSubtests = (test, isCopper) => {
    let { testCount } = this.state;
    let { job, userPreference } = this.props;
    if (
      (job.metadatalookupid === CUSTOM_METADATA_STANDARD || userPreference.FromTreeview) &&
      userPreference.metadata
    ) {
      let metadata = [...userPreference.metadata];
      let curStateMetaData = [...test.metadata];
      metadata.forEach(e => {
        curStateMetaData.forEach(ce => {
          if (ce.level === e.level) {
            ce.field = e.field;
            ce.value = e.value;
            e.value ? (ce.enabled = true) : (ce.enabled = false);
          }
        });
      });
      test.metadata = curStateMetaData;
      test.allmetadataoptions = true;
      this.setState({
        test: {
          ...test
        }
      });
    }
  };

  handleTabChange = (event, value) => {
    let { tabPosition } = this.state;
    let prevTabClicked = tabPosition > value;
    let allowTabChange = prevTabClicked ? true : this.validate();
    if (allowTabChange) {
      this.setState({ tabPosition: value });
    }
  };

  tabNext() {
    let check = this.canTabNext();
    let validate = this.validate();
    if (validate && check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    let check = this.canTabBack();
    if (check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    const { tabs, tabPosition } = this.state;
    let pos = tabPosition + 1;
    return pos < tabs.filter(n => n).length
      ? { can: true, pos: pos }
      : { can: false, pos: pos };
  }

  canTabBack() {
    const { tabPosition } = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? { can: true, pos: pos } : { can: false, pos: pos };
  }

  tabsComplete() {
    const { tabs, tabPosition } = this.state;
    return tabPosition === tabs.filter(n => n).length - 1 ? true : false;
  }

  handleClose = () => {
    this.setState({
      open: false
    });
    this.props.cancel("cancel");
  };

  setInsertionLoss = () => {
    const { fiberStandards } = this.props;
    const { test } = this.state;

    let cabletype = fiberStandards.cablebrands;
    let typeDetails = cabletype.find(x => x.id === test.cablebrand.id)
      .cabletypedetails;
    let partdetailsObj = typeDetails.find(x => x.id === test.cabletype.id)
      .cablepartdetails;
    partdetailsObj;
  };

  onChange = (e, isObj, cableTypes) => {
    let test = { ...this.state.test };
    let errors = { ...this.state.errors };
    let {
      cabletypes,
      cableparts,
      cablebrands,
      fiberappgroups,
      fiberstdgroups,
      wavelengthdetails,
      wavelengths,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      allowEditMaxLength,
      allowApplyLength,
      disableRefractiveIndex,
      appDetails,
      stdDetails
    } = this.state;
    const { fiberStandards, lengthMeasurementUnit } = this.props;

    errors = {
      ...errors,
      [e.target.name]: false
    };
    if (
      e.target.name === "startvalue" &&
      e.target.value.trim() === "" &&
      test.startvalue === ""
    ) {
      return;
    }
    const { job, translate } = this.props;
    let value;
    if (
      job.metadatalookupid !== null &&
      job.metadatalookupid !== CUSTOM_METADATA_STANDARD
    ) {
      if (e.target.name === "floor")
        value =
          e.target.value.length <= 3 ? e.target.value : test[e.target.name];
      if (e.target.name === "telecommunicationspace")
        value =
          e.target.value.length <= 1 ? e.target.value : test[e.target.name];
      if (e.target.name === "panel")
        value =
          e.target.value.length <= 2 ? e.target.value : test[e.target.name];
      if (e.target.name === "startvalue")
        value =
          e.target.value.length <= 4 ? e.target.value : test[e.target.name];
      if (e.target.name === "endvalue")
        value =
          e.target.value.length <= 4 ? e.target.value : test[e.target.name];
    }

    if (e.target.name === "cablebrand") {
      cabletypes = cablebrands
        ? cablebrands.find(x => x.id === e.target.value)
        : null;
      if (cabletypes.name.toLowerCase().includes("generic")) {
        disableRefractiveIndex = false;
      } else {
        disableRefractiveIndex = true;
      }
      cabletypes =
        cabletypes && cabletypes.cabletypedetails
          ? cabletypes.cabletypedetails
          : null;
      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test.cablepart = "";
        test.cabletype = "";
        test.refractiveindex = 1.49;
        cableparts = [];
      }
    }

    if (e.target.name === "cabletype") {
      cableparts = cabletypes
        ? cabletypes.find(x => x.id === e.target.value)
        : null;
      this.cableType = cableparts ? cableparts.type : null;
      cableparts = cableparts ? cableparts.cablepartdetails : null;
      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test.cablepart = "";
        test.refractiveindex = 1.49;
      }

      const cableObj = {
        id: e.target.value,
        name: e.nativeEvent.target.outerText
          ? e.nativeEvent.target.outerText.trim()
          : e.nativeEvent.target.innerText
          ? e.nativeEvent.target.innerText
          : ""
      };
      test[e.target.name] = cableObj;

      // filter wavelengths value based on cableType (Sm/ Mm)
      if (
        test.limitmethodtype &&
        [
          "Manual Loss Budget",
          "Loss Budget Calculator",
          "Applications"
        ].includes(test.limitmethodtype.name)
      ) {
        if (this.cableType) {
          let wavelengthDetails = wavelengthdetails
            ? wavelengthdetails.find(x => x.cabletype === this.cableType)
            : null;
          wavelengths =
            wavelengthDetails && wavelengthDetails.wavelength
              ? wavelengthDetails.wavelength
              : [];
          if (e.target.value != 1) {
            test.limitwavelength =
              wavelengthDetails && wavelengthDetails.wavelength
                ? wavelengthDetails.wavelength.find(x => x.id === 2)
                : null;
          }
          if (wavelengthDetails && wavelengthDetails.wavelengthvalue) {
            let waveLengthValue = wavelengthDetails.wavelengthvalue;
            this.budgetLossMin = waveLengthValue[0];
            this.budgetLossMax = waveLengthValue[1];
          }
          test.callimitlength = true;
          test.measurelength = true;
          allowApplyLength = false;
          allowEditMaxLength = false;
          test.illosswllow = "";
          test.illosswlhigh = "";
          disbleBudgetLossMin = false;
          disbleBudgetLossMax = false;
        }
      }

      // filter groups based on cabletypeName when limit method type is cabling standard
      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Cabling Standards"
      ) {
        fiberstdgroups = fiberStandards.stdgroups;
        fiberstdgroups = fiberstdgroups.filter(standardDetailsObj => {
          let o = standardDetailsObj.standarddetails.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          if (o.length) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Applications"
      ) {
        // filter groups based on cabletypeName when limit method type is application
        fiberappgroups = fiberStandards.appgroups;
        fiberappgroups = fiberappgroups.filter(applicationDetailsObj => {
          let o = applicationDetailsObj.applications.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          if (o.length) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (test.standard != null && typeof test.standard === "object") {
        let standarddDetails = fiberstdgroups
          ? fiberstdgroups.find(x => x.id === test.group.id)
          : null;
        if (!standarddDetails) {
          test.standard = "";
          test.maxlength = "";
          test.illosswlhigh = "";
          test.illosswllow = "";
          test.group = "";
        } else {
          // filter standards based on cabletypeName
          if (
            standarddDetails &&
            standarddDetails.standarddetails &&
            test.cabletype.name
          ) {
            standarddDetails = standarddDetails.standarddetails.filter(obj => {
              let m = obj.lengthdetails.filter(
                o =>
                  o.name === test.cabletype.name &&
                  (o.length != null ||
                    o.lossbudgetlow != null ||
                    o.lossbudgethigh != null)
              );
              if (m.length) {
                return true;
              } else {
                return false;
              }
            });
            stdDetails = standarddDetails ? standarddDetails : [];
          }

          standarddDetails = stdDetails.find(x => x.id === test.standard.id);
          if (!standarddDetails) {
            test.standard = "";
            test.maxlength = "";
            test.illosswlhigh = "";
            test.illosswllow = "";
          } else {
            let maxObj =
              standarddDetails && standarddDetails.lengthdetails
                ? standarddDetails.lengthdetails.find(
                    x => x.name === test.cabletype.name
                  )
                : {};
            test.maxlength = maxObj && maxObj.length ? maxObj.length : "";
            test.maxlength =
              test.maxlength &&
              (lengthMeasurementUnit == "feet"
                ? Math.round((test.maxlength / 0.3048) * 100) / 100
                : test.maxlength);
            test.illosswllow =
              maxObj && maxObj.lossbudgetlow ? maxObj.lossbudgetlow : "";
            test.illosswlhigh =
              maxObj && maxObj.lossbudgethigh ? maxObj.lossbudgethigh : "";
          }
        }
      }

      if (test.application != null && typeof test.application === "object") {
        let applicationDetails = fiberappgroups
          ? fiberappgroups.find(x => x.id === test.group.id)
          : null;
        if (!applicationDetails) {
          test.application = "";
          test.maxlength = "";
          test.illosswlhigh = "";
          test.illosswllow = "";
          test.group = "";
        } else {
          // filter applications based on cabletypeName
          if (
            applicationDetails &&
            applicationDetails.applications &&
            test.cabletype.name
          ) {
            applicationDetails = applicationDetails.applications.filter(obj => {
              let m = obj.lengthdetails.filter(
                o =>
                  o.name === test.cabletype.name &&
                  (o.length != null ||
                    o.lossbudgetlow != null ||
                    o.lossbudgethigh != null)
              );
              if (m.length) {
                return true;
              } else {
                return false;
              }
            });
            appDetails = applicationDetails ? applicationDetails : [];
          }

          applicationDetails = appDetails.find(
            x => x.id === test.application.id
          );
          if (!applicationDetails) {
            test.application = "";
            test.maxlength = "";
            test.illosswlhigh = "";
            test.illosswllow = "";
          } else {
            let lossObj =
              applicationDetails && applicationDetails.lengthdetails
                ? applicationDetails.lengthdetails.find(
                    x => x.name === test.cabletype.name
                  )
                : {};
            test.maxlength = lossObj && lossObj.length ? lossObj.length : "";
            test.maxlength =
              test.maxlength &&
              (lengthMeasurementUnit == "feet"
                ? Math.round((test.maxlength / 0.3048) * 100) / 100
                : test.maxlength);
            test.illosswllow =
              lossObj && lossObj.lossbudgetlow ? lossObj.lossbudgetlow : "";
            test.illosswlhigh =
              lossObj && lossObj.lossbudgethigh ? lossObj.lossbudgethigh : "";
          }
        }
      }
    }

    if (e.target.name === "cablepart") {
      let cablePart = cableparts
        ? cableparts.find(x => x.id === e.target.value)
        : null;
      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test.refractiveindex = 1.49;
      }
      test.refractiveindex = this.cableType
        ? this.cableType.toLowerCase() == "mm"
          ? cablePart.rihigh
          : cablePart.rilow
        : 1.49;
    }

    if (e.target.name === "limitmethodtype") {
      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test["measurelength"] = false;
        test["callimitlength"] = false;
        test["maxlength"] = lengthMeasurementUnit == "feet" ? 3280.84 : 1000;
        test["group"] = "";
        test["standard"] = "";
        test["application"] = "";
        test["spliceloss"] = 0.3;
        test["adapterloss"] = 0.75;
        test["adapterscount"] = 2;
        test["splicecount"] = 0;
        test["illosswllow"] = 0;
        test["illosswlhigh"] = 0;
        test["limitwavelength"] = "";
        test["cordlosstype"] = { id: 0 };
        disbleBudgetLossMin = false;
        disbleBudgetLossMax = false;
        // if applications and loss budget calculator
        if ([1, 2, 3].includes(e.target.value)) {
          if (this.cableType) {
            let wavelengthDetails = wavelengthdetails
              ? wavelengthdetails.find(x => x.cabletype === this.cableType)
              : null;
            wavelengths =
              wavelengthDetails && wavelengthDetails.wavelength
                ? wavelengthDetails.wavelength
                : [];
            if (e.target.value != 1) {
              test.limitwavelength =
                wavelengthDetails && wavelengthDetails.wavelength
                  ? wavelengthDetails.wavelength.find(x => x.id === 2)
                  : null;
            }
            if (wavelengthDetails && wavelengthDetails.wavelengthvalue) {
              let waveLengthValue = wavelengthDetails.wavelengthvalue;
              this.budgetLossMin = waveLengthValue[0];
              this.budgetLossMax = waveLengthValue[1];
            }
            test.callimitlength = true;
            test.measurelength = true;
            allowApplyLength = false;
            allowEditMaxLength = false;
          }
        } else {
          test.callimitlength = false;
          test.measurelength = false;
          allowApplyLength = true;
          allowEditMaxLength = true;
        }

        // if cabling standard and manual loss budget selected in limit method type
        if ([0, 3].includes(e.target.value)) {
          test.adapterscount = "2";
          test.splicecount = "0";
        }

        // filter groups based on cabletypeName  when limit method type is cabling standard
        if ([0].includes(e.target.value)) {
          fiberstdgroups = fiberstdgroups.filter(standardDetailsObj => {
            let o = standardDetailsObj.standarddetails.filter(obj => {
              let m = obj.lengthdetails.filter(
                o =>
                  o.name === test.cabletype.name &&
                  (o.length != null ||
                    o.lossbudgetlow != null ||
                    o.lossbudgethigh != null)
              );
              if (m.length) {
                return true;
              } else {
                return false;
              }
            });
            if (o.length) {
              return true;
            } else {
              return false;
            }
          });
        }

        // filter groups based on cabletypeName when limit method type is application
        if ([1].includes(e.target.value)) {
          fiberappgroups = fiberappgroups.filter(applicationDetailsObj => {
            let o = applicationDetailsObj.applications.filter(obj => {
              let m = obj.lengthdetails.filter(
                o =>
                  o.name === test.cabletype.name &&
                  (o.length != null ||
                    o.lossbudgetlow != null ||
                    o.lossbudgethigh != null)
              );
              if (m.length) {
                return true;
              } else {
                return false;
              }
            });
            if (o.length) {
              return true;
            } else {
              return false;
            }
          });
        }
      }
    }

    if (e.target.name === "limitwavelength") {
      if (this.cableType) {
        wavelengths = wavelengthdetails
          ? wavelengthdetails.find(x => x.cabletype === this.cableType)
          : null;
        if (wavelengths && wavelengths.wavelengthvalue) {
          let waveLengthValue = wavelengths.wavelengthvalue;
          this.budgetLossMin = waveLengthValue[0];
          this.budgetLossMax = waveLengthValue[1];
        }
      }
      wavelengths = wavelengths.wavelength;
      if (wavelengths) {
        if (e.target.value === 0) {
          disbleBudgetLossMin = false;
          disbleBudgetLossMax = true;
          delete errors["illosswllow"];
          test.illosswlhigh = "";
        } else if (e.target.value === 1) {
          disbleBudgetLossMin = true;
          disbleBudgetLossMax = false;
          delete errors["illosswlhigh"];
          test.illosswllow = "";
        } else {
          disbleBudgetLossMin = false;
          disbleBudgetLossMax = false;
          delete errors["illosswllow"];
          delete errors["illosswlhigh"];
        }
      }
    }

    if (e.target.name === "group") {
      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Cabling Standards"
      ) {
        let standarddDetails = fiberstdgroups
          ? fiberstdgroups.find(x => x.id === e.target.value)
          : null;
        if (
          standarddDetails &&
          standarddDetails.standarddetails &&
          test.cabletype.name
        ) {
          standarddDetails = standarddDetails.standarddetails.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          stdDetails = standarddDetails ? standarddDetails : [];
        }
      }

      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Applications"
      ) {
        let applicationDetails = fiberappgroups
          ? fiberappgroups.find(x => x.id === e.target.value)
          : null;
        if (
          applicationDetails &&
          applicationDetails.applications &&
          test.cabletype.name
        ) {
          applicationDetails = applicationDetails.applications.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          appDetails = applicationDetails ? applicationDetails : [];
        }
      }

      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test["application"] = "";
        test["standard"] = "";
        test["illosswllow"] = "";
        test["illosswlhigh"] = "";
        test["maxlength"] = "";
      }
    }

    if (e.target.name === "standard") {
      if (e.target.value && test.cabletype.name) {
        let lengthDetails = stdDetails.find(x => x.id === e.target.value);
        let maxObj =
          lengthDetails && lengthDetails.lengthdetails
            ? lengthDetails.lengthdetails.find(
                x => x.name === test.cabletype.name
              )
            : {};
        test.maxlength = maxObj && maxObj.length ? maxObj.length : "";
        test.maxlength =
          test.maxlength &&
          (lengthMeasurementUnit == "feet"
            ? Math.round((test.maxlength / 0.3048) * 100) / 100
            : test.maxlength);
        test.illosswllow =
          maxObj && maxObj.lossbudgetlow ? maxObj.lossbudgetlow : "";
        test.illosswlhigh =
          maxObj && maxObj.lossbudgethigh ? maxObj.lossbudgethigh : "";
      }
    }

    if (e.target.name === "application") {
      if (e.target.value && test.cabletype.name) {
        let lengthDetails = appDetails.find(x => x.id === e.target.value);
        let lossObj =
          lengthDetails && lengthDetails.lengthdetails
            ? lengthDetails.lengthdetails.find(
                x => x.name === test.cabletype.name
              )
            : {};
        test.maxlength = lossObj && lossObj.length ? lossObj.length : "";
        test.maxlength =
          test.maxlength &&
          (lengthMeasurementUnit == "feet"
            ? Math.round((test.maxlength / 0.3048) * 100) / 100
            : test.maxlength);
        test.illosswllow =
          lossObj && lossObj.lossbudgetlow ? lossObj.lossbudgetlow : "";
        test.illosswlhigh =
          lossObj && lossObj.lossbudgethigh ? lossObj.lossbudgethigh : "";
      }
    }

    if (isObj) {
      if (value) {
        test[e.target.name] = value;
      } else {
        let tempObj = {};
        tempObj.id = e.target.value;
        tempObj.name = e.nativeEvent.target.outerText
          ? e.nativeEvent.target.outerText.trim()
          : e.nativeEvent.target.innerText
          ? e.nativeEvent.target.innerText
          : "";
        test[e.target.name] = tempObj;
      }
    } else {
      test[e.target.name] = value ? value : e.target.value;
    }

    if (e.target.name === "startvalue") {
      test["endvalue"] = value ? value : e.target.value;
    }
    if (
      job.metadatalookupid !== null &&
      job.metadatalookupid !== CUSTOM_METADATA_STANDARD
    ) {
      test.prefix = `${test.floor}-${test.telecommunicationspace}-${test.panel}`;
    }

    if (
      this.state.testIDType == "sequential" &&
      test.startvalue &&
      test.endvalue &&
      test.prefix
    ) {
      let names = generateNames(
        test.prefix,
        test.startvalue,
        test.endvalue,
        2000,
        errors
      );
      if (names) {
        test.names = names;
        delete errors.startvalue;
        delete errors.endvalue;
      } else {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.startvalue
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.endvalue
        )} ]`;
        if (this.state.testIDType != "import") test.names = null;
      }
    } else {
      if (this.state.testIDType != "import") test.names = null;
    }
    this.setState({
      test,
      errors,
      allowApplyLength,
      allowEditMaxLength,
      cabletypes,
      cableparts,
      cablebrands,
      wavelengths,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      disableRefractiveIndex,
      stdDetails,
      appDetails,
      fiberappgroups,
      fiberstdgroups
    });
  };

  onLenghtLimitChange = e => {
    let test = { ...this.state.test };
    let { allowApplyLength, allowEditMaxLength } = this.state;
    if (e.target.name === "measurelength") {
      if (test["measurelength"] === false) {
        allowApplyLength = false;
      } else {
        allowApplyLength = true;
        test.callimitlength = false;
        test.maxlength = "";
        allowEditMaxLength = true;
      }
      test.measurelength = !test.measurelength;
    }
    if (e.target.name === "callimitlength") {
      test.maxlength = e.target.value === "true" ? "" : test["maxlength"];
      test.callimitlength = !test.callimitlength;
      allowEditMaxLength = !allowEditMaxLength;
    }

    this.setState({ test, allowEditMaxLength, allowApplyLength });
  };

  onToggleChange = (e, checked) => {
    let test = { ...this.state.test };
    test[e.target.name] = checked;
    this.setState({ test: test });
  };

  onCustomCheckChange = e => {
    let test = { ...this.state.test };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let enabled = !metadataOption.enabled;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      enabled: enabled,
      field: document.querySelector(`select[name="${e.target.name}"]`).value,
      value: ""
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onCustomChange = e => {
    let test = { ...this.state.test };

    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let field = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      field
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onChangeMetadataField = e => {
    let { test, errors } = { ...this.state };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let value = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      value
    };
    errors[e.target.name] = false;
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test, errors });
  };

  validate = currentTab => {
    const {
      test,
      tabPosition,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      disableRefractiveIndex,
      testIDType
    } = this.state;
    const { job, translate, lengthMeasurementUnit } = this.props;
    let validationData = {};
    let errors = {};
    switch (currentTab || currentTab === 0 ? currentTab : tabPosition) {
      case 0:
        if (testIDType == "sequential") {
          if (
            job.metadatalookupid !== null &&
            job.metadatalookupid !== CUSTOM_METADATA_STANDARD
          ) {
            validationData = {
              floor: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 3,
                  message: translate("formfield_error_general_length", {
                    value: 3
                  })
                },
                type: {
                  value: "alphanumeric",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              telecommunicationspace: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 1,
                  message: translate("formfield_error_general_length", {
                    value: 1
                  })
                },
                type: {
                  value: "alphanumeric",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              panel: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 2,
                  message: translate("formfield_error_general_length", {
                    value: 2
                  })
                },
                type: {
                  value: "alphanumeric",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              startvalue: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 4,
                  message: translate("formfield_error_general_length", {
                    value: 4
                  })
                },
                type: {
                  value: "numeric",
                  message: translate("formfield_error_general_type_numeric")
                }
              },
              endvalue: {
                required: translate("formfield_error_general_required"),
                length: {
                  value: 4,
                  message: translate("formfield_error_general_length", {
                    value: 4
                  })
                },
                type: {
                  value: "numeric",
                  message: translate("formfield_error_general_type_numeric")
                }
              }
            };
          } else {
            validationData = {
              prefix: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "alphanumericspecial",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              startvalue: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "alphanumericspecial",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              },
              endvalue: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "alphanumericspecial",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              }
            };
          }
        }
        break;
      case 1:
        validationData = {
          cablebrand: {
            required: translate("formfield_error_general_required")
          },
          cabletype: {
            required: translate("formfield_error_general_required")
          },
          cablepart: {
            required: translate("formfield_error_general_required")
          },
          refractiveindex: {
            required: translate("formfield_error_general_required"),
            type: {
              value: "decimal",
              message: translate("should_be_atmost_two_place_decimal_digit")
            }
          },
          limitmethodtype: {
            required: translate("formfield_error_general_required")
          }
        };
        if (!disableRefractiveIndex) {
          validationData.refractiveindex.range = {
            minValue: 1.3,
            maxValue: 1.55,
            message: translate("fiber_test_refractiveindex_out_of_range_desc")
          };
        }
        break;
      case 2:
        if (test.limitmethodtype.name === "Applications") {
          validationData = {
            cordlosstype: {
              required: translate("formfield_error_general_required")
            },
            group: {
              required: translate("formfield_error_general_required")
            },
            application: {
              required: translate("formfield_error_general_required")
            }
          };
        }

        if (test.limitmethodtype.name === "Cabling Standards") {
          validationData = {
            cordlosstype: {
              required: translate("formfield_error_general_required")
            },
            group: {
              required: translate("formfield_error_general_required")
            },
            standard: {
              required: translate("formfield_error_general_required")
            },
            adapterscount: {
              required: translate("formfield_error_general_required"),
              type: {
                value: "numeric",
                message: translate("formfield_error_general_type_numeric")
              },
              range: {
                minValue: 2,
                maxValue: 8,
                message: translate("fiber_test_noofadapter_out_of_range_desc")
              }
            },
            splicecount: {
              required: translate("formfield_error_general_required"),
              type: {
                value: "numeric",
                message: translate("formfield_error_general_type_numeric")
              },
              range: {
                minValue: 0,
                maxValue: 8,
                message: translate("fiber_test_noofslice_out_of_range_desc")
              }
            }
          };
        }

        if (test.limitmethodtype.name === "Loss Budget Calculator") {
          validationData = {
            limitwavelength: {
              required: translate("formfield_error_general_required")
            },
            cordlosstype: {
              required: translate("formfield_error_general_required")
            },
            adapterscount: {
              required: translate("formfield_error_general_required"),
              type: {
                value: "numeric",
                message: translate("formfield_error_general_type_numeric")
              },
              range: {
                minValue: 2,
                maxValue: 8,
                message: translate("fiber_test_noofadapter_out_of_range_desc")
              }
            },
            splicecount: {
              required: translate("formfield_error_general_required"),
              type: {
                value: "numeric",
                message: translate("formfield_error_general_type_numeric")
              },
              range: {
                minValue: 0,
                maxValue: 8,
                message: translate("fiber_test_noofslice_out_of_range_desc")
              }
            },
            adapterloss: {
              required: translate("formfield_error_general_required"),
              type: {
                value: "decimal",
                message: translate("should_be_atmost_two_place_decimal_digit")
              },
              range: {
                minValue: 0,
                maxValue: 5,
                message: translate("fiber_test_adapterloss_out_of_range_desc")
              }
            },
            spliceloss: {
              required: translate("formfield_error_general_required"),
              type: {
                value: "decimal",
                message: translate("should_be_atmost_two_place_decimal_digit")
              },
              range: {
                minValue: 0,
                maxValue: 5,
                message: translate("fiber_test_spliceloss_out_of_range_desc")
              }
            }
          };
          if (!disbleBudgetLossMin) {
            validationData["illosswllow"] = {
              required: translate("formfield_error_general_required"),
              type: {
                value: "decimal",
                message: translate("should_be_atmost_two_place_decimal_digit")
              },
              range: {
                minValue: 0,
                maxValue: 5,
                message: translate("fiber_test_iloss_out_of_range_desc")
              }
            };
          }
          if (!disbleBudgetLossMax) {
            validationData["illosswlhigh"] = {
              required: translate("formfield_error_general_required"),
              type: {
                value: "decimal",
                message: translate("should_be_atmost_two_place_decimal_digit")
              },
              range: {
                minValue: 0,
                maxValue: 5,
                message: translate("fiber_test_iloss_out_of_range_desc")
              }
            };
          }
          if (test.measurelength && test.callimitlength) {
            validationData["maxlength"] = {
              required: translate("formfield_error_general_required"),
              type: {
                value: "decimal",
                message: translate("should_be_atmost_two_place_decimal_digit")
              },
              range: {
                minValue: 0,
                maxValue: lengthMeasurementUnit == "feet" ? 131233.6 : 40000,
                message:
                  lengthMeasurementUnit == "feet"
                    ? translate("fiber_test_maxlength_out_of_range_desc_feet")
                    : translate("fiber_test_maxlength_out_of_range_desc")
              }
            };
          }
        }

        if (test.limitmethodtype.name === "Manual Loss Budget") {
          validationData = {
            limitwavelength: {
              required: translate("formfield_error_general_required")
            },
            cordlosstype: {
              required: translate("formfield_error_general_required")
            }
          };
          if (!disbleBudgetLossMin) {
            validationData["illosswllow"] = {
              required: translate("formfield_error_general_required"),
              type: {
                value: "decimal",
                message: translate("should_be_atmost_two_place_decimal_digit")
              },
              range: {
                minValue: 0,
                maxValue: 5,
                message: translate("fiber_test_iloss_out_of_range_desc")
              }
            };
          }
          if (!disbleBudgetLossMax) {
            validationData["illosswlhigh"] = {
              required: translate("formfield_error_general_required"),
              type: {
                value: "decimal",
                message: translate("should_be_atmost_two_place_decimal_digit")
              },
              range: {
                minValue: 0,
                maxValue: 5,
                message: translate("fiber_test_iloss_out_of_range_desc")
              }
            };
          }
          if (test.measurelength && test.callimitlength) {
            validationData["maxlength"] = {
              required: translate("formfield_error_general_required"),
              type: {
                value: "decimal",
                message: translate("should_be_atmost_two_place_decimal_digit")
              },
              range: {
                minValue: 0,
                maxValue: lengthMeasurementUnit == "feet" ? 131233.6 : 40000,
                message:
                  lengthMeasurementUnit == "feet"
                    ? translate("fiber_test_maxlength_out_of_range_desc_feet")
                    : translate("fiber_test_maxlength_out_of_range_desc")
              }
            };
          }
        }
        break;
      case 3:
        validationData = {
          testmode: {
            required: translate("formfield_error_general_required")
          },
          direction: {
            required: translate("formfield_error_general_required")
          },
          referencemethod: {
            required: translate("formfield_error_general_required")
          },
          flux: {
            required: translate("formfield_error_general_required")
          },
          connectortype: {
            required: translate("formfield_error_general_required")
          }
        };
        break;
      case 4:
        test.metadata.map(x => {
          if (x.enabled && x.value.trim() === "") {
            errors[x.level] = true;
          } else if (x.enabled && x.value.length > 12) {
            errors[x.level] = true;
          }
        });
        break;
      default:
        return true;
    }

    if (
      tabPosition === 4 &&
      currentTab === tabPosition &&
      job.metadatalookupid === CUSTOM_METADATA_STANDARD
    ) {
    } else {
      errors = validateFormData(test, validationData);
    }

    if (testIDType == "sequential" && tabPosition === 0) {
      errors = validateFormData(test, validationData);
      if (!this.state.test.names && !Object.keys(errors)[0]) {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          "test_maximum_allowed_range"
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          "test_maximum_allowed_range"
        )} ]`;
      }
    }

    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();

      if (Number.isInteger(parseInt(missingFieldName))) {
        toast.error(
          ` ${this.props.translate("test_create_invalid_identifier")}`,
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true
          }
        );
      }
    }

    if (testIDType == "import" && tabPosition === 0) {
      delete errors.startvalue;
      delete errors.endvalue;
      delete errors.prefix;
      if (this.state.lantekfiles == null || this.state.test.names == null || this.state.test.names.length === 0) {
        errors.importFile = "Required";
      }
      else if (this.state.test.names.length > 2000) {
        errors.importFile = "LimitExceeded";
      }
      // validationData = {
      //   lantekfiles: {
      //     required: translate("formfield_error_general_required")
      //   }
      // };
    }

    if (Object.keys(errors).length) {
      if (!currentTab && currentTab !== 0) {
        this.setState({ errors });
      } else {
        this.setState({ errors, tabPosition: currentTab });
      }
      return false;
    } else {
      this.setState({ errors });
      return true;
    }
  };

  createTests() {
    let isValidated = false;
    const { tabPosition } = this.state;
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab);
      if (!isValidated) {
        return;
      }
    }
    
    if (isValidated) {
      let { test, testIDType } = this.state;
      const { job, pager, lengthMeasurementUnit, userPreference } = this.props;

      if (
        job.metadatalookupid !== null &&
        job.metadatalookupid !== CUSTOM_METADATA_STANDARD && (userPreference && !userPreference.FromTreeview)) {
        test.prefix = `${test.floor}-${test.telecommunicationspace}-${test.panel}`;
      }

      //Remove Disabled Metadata
      if (job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) {
        let metadata = [...test.metadata];
        metadata.map(e => {
          if (!e.enabled) {
            e.field = "";
            e.value = "";
            return e;
          }
        });
        test.metadata = metadata;
      }
      if (job.metadatalookupid !== CUSTOM_METADATA_STANDARD && (userPreference && !userPreference.FromTreeview)) {
        var tempMetadata = test.metadata.map(i => {
          return { ...i, ...{ value: null } };
        });
        test = { ...test, metadata: tempMetadata };
      }
      if (test["refractiveindex"]) {
        test.refractiveindex = parseFloat(test["refractiveindex"]);
      }
      test.maxlength =
        lengthMeasurementUnit == "feet"
          ? Math.round(test.maxlength * 0.3048 * 100) / 100
          : test.maxlength;
      if (testIDType === "import") {
        test.names = test.names.filter(
          (value, index) => test.names.indexOf(value) === index
        );
      }
      this.props.saveNewTests(test, pager);
    }
  }

  onTestPrefixTypeChange(e) {
    let test = { ...this.state.test };
    let testPrefixType = e.target.value;

    let errors = { ...this.state.errors };

    const { translate } = this.props;

    if (e.target.value !== "custom") {
      test.prefix =
        this.props.custom
          .find(cust => cust.level === 1)
          .values.find(obj => {
            return obj.id === e.target.value;
          }).name || "";
    } else {
      test.prefix = "";
    }
    if (test.startvalue && test.endvalue && test.prefix) {
      let names = generateNames(
        test.prefix,
        test.startvalue,
        test.endvalue,
        10000,
        errors
      );
      if (names) {
        test.names = names;
        delete errors.startvalue;
        delete errors.endvalue;
      } else {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.startvalue
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.endvalue
        )} ]`;
        test.names = null;
      }
    } else {
      test.names = null;
    }
    this.setState({
      test,
      testPrefixType
    });
  }

  onTestIDTypeChange = e => {
    let { errors } = { ...this.state };
    let test = { ...this.state.test };
    //this.setState({ testIDType: e.target.value });
    if (e.target.value == "import") {
      errors.startvalue = false;
      errors.endvalue = false;
      errors.prefix = false;
    }
    errors.importFile = false;
    test.names = null;
    test.prefix = "";
    test.startvalue = "01";
    test.endvalue = "24";
    this.setState({
      testIDType: e.target.value,
      errors,
      test,
      testPrefixType: "custom",
      lantekfiles: null
    });
  };

  handleUpload() {
    let fd = new FormData();
    let lantekfiles = { ...this.state.lantekfiles };
    let { errors } = { ...this.state };
    Object.keys(lantekfiles).forEach(key => {
      fd.append("file", lantekfiles[key]);
    });
    errors.importFile = false;
    //alert("test");
    this.props.clearDuplicateError();
    this.props.uploadTestIDFile(fd);
    this.setState({
      errors
    });
    // this.props
    //   .uploadTestIDFile(fd)
    //   .then(resp => {
    //     // self.closeUploadLantekModal();
    //     // self.closeImportTestModal();
    //   })
    //   .catch(errors => {
    //     console.log("ERRRRRRR" + errors);
    //   });
  }

  handleImport(e) {
    let { errors } = { ...this.state };
    errors.importFile = false;
    this.setState({
      errors
    });
    if (e.target.type == "file" && e.target.files.length) {
      // const totalBytes = Object.keys(e.target.files).reduce(
      //   (total, file) => total + e.target.files[file].size,
      //   0
      // );
      // 1 MB = 1048576 bytes
      // if (Math.round(totalBytes / 1048576) >= APP_CONFIG.maxFileUploadSize) {
      //   toast.error(
      //     ` ${this.props.translate(
      //       "jobs_upload_lantek_files_large_filesize_unsuccessfull_toast"
      //     )}`,
      //     {
      //       position: toast.POSITION.TOP_CENTER,
      //       hideProgressBar: true
      //     }
      //   );
      //   document.getElementById("lantekfiles").value = "";
      //   this.setState({
      //     lantekfiles: null,
      //     testFileArray: null,
      //     jobFileArray: null
      //   });
      //   return;
      // }
      this.setState({
        [e.target.name]: e.target.files
        // testFileArray: Array.from(e.target.files).filter(
        //   file =>
        //     file.name
        //       .split(".")
        //       .pop()
        //       .toLowerCase() !== "job"
        // ),
        // jobFileArray: Array.from(e.target.files).filter(
        //   file =>
        //     file.name
        //       .split(".")
        //       .pop()
        //       .toLowerCase() === "job"
        // )
      });
    }
  }

  render() {
    const { classes, translate, job } = this.props;

    let {
      custom,
      standards,
      fiberStandards,
      error,
      lengthMeasurementUnit,
      IDerrors
    } = this.props;

    let metadataOption;
    let {
      test,
      errors,
      tabs,
      testPrefixType,
      tabPosition,
      disabledToogleIdentifier,
      allowApplyLength,
      allowEditMaxLength,
      boolValue,
      lossBudget,
      fiberappgroups,
      cablebrands,
      fiberstdgroups,
      testmode,
      direction,
      testcordreference,
      connectortype,
      wavelengths,
      wavelengthdetails,
      cordtypes,
      cabletypes,
      cableparts,
      stdDetails,
      appDetails,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      disableRefractiveIndex,
      testIDType,
      lantekfiles,
      modalRef,
      multiCordTypes
    } = this.state;

    if (!custom) return null;

    custom = custom.sort((a, b) => b.level > a.level);
    let showAllMetadataSwitch =
      this.state.test.metadata.filter(n => n.field).length !== 6;
      
    function testCordTypeField(onChange) {
      let selectedGroup = (test.group) ? test.group.name : "";
      if (selectedGroup != "ANSI/TIA") selectedGroup = "other";
      let selectedCType = test.cabletype.name; 
      if(selectedCType.startsWith("OM")) selectedCType = "MM";
      if(selectedCType.startsWith("OS")) selectedCType = "SM";
      let options = cordtypes;

      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Cabling Standards" &&
        multiCordTypes
      ) {
        const matchedType = multiCordTypes.find(
          x => x.group === selectedGroup && x.cabletype === selectedCType
        );       
        options = matchedType ? matchedType.refCordLoss : [];
        
      }         
      return (
          <FormControl
            fullWidth
            margin="normal"
            required
            error={errors.cordlosstype ? true : false}
          >
            <InputLabel htmlFor="cordlosstype">
              {translate("test_cord_type")}
            </InputLabel>
            <Select
              value={
                test.cordlosstype ? test.cordlosstype.id : ""
              }
              onChange={e => onChange(e, true)}
              input={
                <Input
                  name="cordlosstype"
                  id="cordlosstype"
                  value={
                    test.cordlosstype ? test.cordlosstype.id : ""
                  }
                  fullWidth
                />
              }
              
            >
              {options
                ? options.map((cord, index) => {
                    return (
                      <MenuItem key={index} value={cord.id}>
                        {cord.name}
                      </MenuItem>
                    );
                  })
                : null}
            </Select>
            <FormHelperText>
              {errors.cordlosstype
                ? errors.cordlosstype
                : translate("test_cord_type")}
            </FormHelperText>
          </FormControl>
        )
    }

    return (
      <Modal open={this.state.open} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_add")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents>
              {error && error === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_duplicate_error")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "invalid_character" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_char")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "maximum_length_exceed" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_length")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "too_many_test_to_import" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_numbers")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "error_wrongfiletype" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_type")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              <form noValidate autoComplete="off" className={classes.form} ref={modalRef}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {tabs.map((tab, index) => {
                    return <Tab key={index} label={tab} />;
                  })}
                </Tabs>

                {tabPosition === 0 && (
                  <div className={classes.summary}>
                    {(job.metadatalookupid === null ||
                      job.metadatalookupid === CUSTOM_METADATA_STANDARD) && (
                      <div>
                        <FormControl>
                          <RadioGroup
                            aria-label="chartLine"
                            name="chartLine"
                            className={classes.group}
                            value={testIDType}
                            onChange={this.onTestIDTypeChange}
                            row={true}
                          >
                            <FormControlLabel
                              value="sequential"
                              control={<Radio />}
                              label={translate("sequential_test_ids")}
                            />
                            <FormControlLabel
                              value="import"
                              control={<Radio />}
                              label={translate("import_test_ids")}
                            />
                          </RadioGroup>
                        </FormControl>
                        {testIDType === "import" && (
                          <div>
                            {/* <form
                              noValidate
                              autoComplete="off"
                              className={classes.form_inner}
                            > */}
                            <div className={classes.uploadlabel}>
                              <InputLabel
                                htmlFor="testPrefixType"
                                className={classes.fileUpload}
                              >
                                {translate("select_spreadsheet_to_import")}
                              </InputLabel>
                            </div>
                            <FormControl
                              fullWidth
                              error={errors.lantekfiles ? true : false}
                            >
                              <Input
                                className={classes.upload}
                                id="lantekfiles"
                                type="file"
                                name="lantekfiles"
                                onChange={this.handleImport}
                                inputProps={{
                                  name: "lantekfiles",
                                  multiple: false,
                                  accept: ".xlsx,.csv"
                                }}
                                error={errors.lantekfiles ? true : false}
                                helperText={
                                  errors.lantekfiles
                                    ? errors.lantekfiles
                                    : 'translate("test_custom_prefix_help")'
                                }
                              />
                              {/* <FormHelperText id="lantekfiles-helper-text">
                              {"Please Select a single file."}
                            </FormHelperText> */}
                            </FormControl>
                            {/* </form> */}
                            <Button
                              className={classes.import}
                              error={errors.importFile ? true : false}
                              raised
                              color="primary"
                              onClick={this.handleUpload}
                              disabled={lantekfiles == null}
                              helperText={
                                errors.importFile
                                  ? errors.importFile
                                  : 'translate("test_custom_prefix_help")'
                              }
                            >
                              {translate("general_import").toUpperCase()}
                            </Button>
                            {/* {$fileLists}
                          {$jobFile} */}
                            <HtmlTooltip
                              title={
                                <React.Fragment>
                                  <ul>
                                    <li>{translate("test_ids_tooltip_1")}</li>
                                    <li>{translate("test_ids_tooltip_2")}</li>
                                    <li>{translate("test_ids_tooltip_3")}</li>
                                    <li>{translate("test_ids_tooltip_4")}</li>
                                  </ul>
                                </React.Fragment>
                              }
                            >
                              <div className={classes.tooltip}>[?]</div>
                            </HtmlTooltip>
                            {(errors.importFile === "Required") && (
                              <Typography className={classes.uploadValidation}>
                                {translate("import_test_ids_required")}
                              </Typography>
                            )}
                            {(errors.importFile === "LimitExceeded") && (
                              <Typography className={classes.uploadValidation}>
                                {translate("import_test_ids_limit_exceeded")}
                              </Typography>
                            )}
                          </div>
                        )}
                        {testIDType === "sequential" && (
                          <FormControl
                            className={classes.textField}
                            margin="normal"
                          >
                            <InputLabel htmlFor="testPrefixType">
                              {translate("test_prefix")}
                            </InputLabel>
                            <Select
                              value={testPrefixType}
                              onChange={this.onTestPrefixTypeChange.bind(this)}
                              input={
                                <Input
                                  name="testPrefixType"
                                  id="testPrefixType"
                                  value={testPrefixType}
                                />
                              }
                              fullWidth
                            >
                              {custom
                                ? custom
                                    .find(c => c.level === 1)
                                    .values.map((c, index) => {
                                      return (
                                        <MenuItem
                                          key={`testPrefixType-${index}`}
                                          value={c.id}
                                        >
                                          {c.name}
                                        </MenuItem>
                                      );
                                    })
                                : null}
                              <MenuItem
                                key="testPrefixTypeCustom"
                                value="custom"
                              >
                                {translate("test_custom")}
                              </MenuItem>
                            </Select>
                            <FormHelperText>
                              {errors.cablestandard
                                ? errors.cablestandard
                                : translate("test_prefix_help")}
                            </FormHelperText>
                          </FormControl>
                        )}
                        {testIDType === "sequential" &&
                          testPrefixType === "custom" && (
                            <TextField
                              error={errors.prefix ? true : false}
                              required
                              name="prefix"
                              label={translate("test_custom_prefix")}
                              margin="normal"
                              fullWidth
                              value={test.prefix}
                              onChange={this.onChange}
                              inputProps={{
                                maxlength: 76
                              }}
                              helperText={
                                errors.prefix
                                  ? errors.prefix
                                  : translate("test_custom_prefix")
                              }
                            />
                          )}
                        {testIDType === "sequential" && (
                          <TextField
                            error={errors.startvalue ? true : false}
                            required
                            name="startvalue"
                            label={translate("test_startvalue")}
                            margin="normal"
                            fullWidth
                            value={test.startvalue}
                            onChange={this.onChange}
                            helperText={
                              errors.startvalue
                                ? errors.startvalue
                                : translate("test_startvalue")
                            }
                          />
                        )}
                        {testIDType === "sequential" && (
                          <TextField
                            error={errors.endvalue}
                            required
                            name="endvalue"
                            label={translate("test_endvalue")}
                            margin="normal"
                            fullWidth
                            value={test.endvalue}
                            onChange={this.onChange}
                            helperText={
                              errors.endvalue
                                ? errors.endvalue
                                : translate("test_endvalue")
                            }
                          />
                        )}
                        {test.names && (
                          <React.Fragment>
                            <Grid container className={classes.testRange}>
                              <Grid item xs={12} sm={6}>
                                <Typography type="caption">
                                  {translate("test_ranges")}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography type="caption" align="right">
                                  {translate("test_ranges_total")} -{" "}
                                  <strong
                                    style={{ color: "rgba(0, 0, 0, 0.87)" }}
                                  >
                                    {test.names.length}
                                  </strong>
                                </Typography>
                              </Grid>
                            </Grid>
                            <List
                              disablePadding={true}
                              className={classes.scrollableList}
                            >
                              {test.names.map((val, i) => {
                                return (
                                  <ListItem key={`testnames-${i}`}>
                                    <ListItemText primary={val} />
                                  </ListItem>
                                );
                              })}
                            </List>
                          </React.Fragment>
                        )}
                      </div>
                    )}
                    {job.metadatalookupid &&
                      job.metadatalookupid !== CUSTOM_METADATA_STANDARD && (
                        <div>
                          <div className={classes.summary}>
                            <TextField
                              error={errors.floor ? true : false}
                              required
                              name="floor"
                              label={translate("test_floor")}
                              margin="normal"
                              fullWidth
                              value={test.floor}
                              onChange={this.onChange}
                              helperText={
                                errors.floor
                                  ? errors.floor
                                  : translate("test_floor_help")
                              }
                            />

                            <TextField
                              error={
                                errors.telecommunicationspace ? true : false
                              }
                              required
                              name="telecommunicationspace"
                              label={translate("test_telecommunicationspace")}
                              margin="normal"
                              fullWidth
                              value={test.telecommunicationspace}
                              onChange={this.onChange}
                              helperText={
                                errors.telecommunicationspace
                                  ? errors.telecommunicationspace
                                  : translate(
                                      "test_telecommunicationspace_help"
                                    )
                              }
                            />
                            <TextField
                              error={errors.panel ? true : false}
                              required
                              name="panel"
                              label={translate("test_panel")}
                              margin="normal"
                              fullWidth
                              value={test.panel}
                              onChange={this.onChange}
                              helperText={
                                errors.panel
                                  ? errors.panel
                                  : translate("test_panel_help")
                              }
                            />

                            <TextField
                              error={errors.startvalue ? true : false}
                              required
                              name="startvalue"
                              label={translate("test_portstartvalue")}
                              margin="normal"
                              fullWidth
                              value={test.startvalue}
                              onChange={this.onChange}
                              helperText={
                                errors.startvalue
                                  ? errors.startvalue
                                  : translate("test_portstartvalue_help")
                              }
                            />
                            <TextField
                              error={errors.endvalue ? true : false}
                              required
                              name="endvalue"
                              label={translate("test_portendvalue")}
                              margin="normal"
                              fullWidth
                              value={test.endvalue}
                              onChange={this.onChange}
                              helperText={
                                errors.endvalue
                                  ? errors.endvalue
                                  : translate("test_portendvalue_help")
                              }
                            />
                          </div>
                          {test.names && (
                            <React.Fragment>
                              <Grid container>
                                <Grid item xs={12} sm={6}>
                                  <Typography type="caption">
                                    {translate("test_ranges")}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <Typography type="caption" align="right">
                                    {translate("test_ranges_total")} -{" "}
                                    {test.names.length}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <List
                                disablePadding={true}
                                className={classes.scrollableList}
                              >
                                {test.names.map((val, i) => {
                                  return (
                                    <ListItem key={`testnames-${i}`}>
                                      <ListItemText primary={val} />
                                    </ListItem>
                                  );
                                })}
                              </List>
                            </React.Fragment>
                          )}
                        </div>
                      )}
                  </div>
                )}

                {tabPosition === 1 && (
                  <div className={classes.summary}>
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.cablebrand ? true : false}
                    >
                      <InputLabel htmlFor="cablebrand">
                        {translate("cable_brand")}
                      </InputLabel>
                      <Select
                        value={test.cablebrand ? test.cablebrand.id : ""}
                        onChange={e => this.onChange(e, true)}
                        input={
                          <Input
                            name="cablebrand"
                            id="cablebrand"
                            value={test.cablebrand ? test.cablebrand.id : ""}
                          />
                        }
                        fullWidth
                      >
                        {cablebrands
                          ? cablebrands.map((cablebrand, index) => {
                              return (
                                <MenuItem key={index} value={cablebrand.id}>
                                  {cablebrand.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.cablebrand
                          ? errors.cablebrand
                          : translate("cable_brand")}
                      </FormHelperText>
                    </FormControl>

                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.cabletype ? true : false}
                    >
                      <InputLabel htmlFor="cabletype">
                        {translate("test_cable_type")}
                      </InputLabel>
                      <Select
                        value={test.cabletype ? test.cabletype.id : ""}
                        onChange={e => this.onChange(e, true, cabletypes)}
                        input={
                          <Input
                            name="cabletype"
                            id="cabletype"
                            value={test.cabletype ? test.cabletype.id : ""}
                          />
                        }
                        fullWidth
                      >
                        {cabletypes
                          ? cabletypes.map((standard, index) => {
                              return (
                                <MenuItem key={index} value={standard.id}>
                                  {standard.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.cabletype
                          ? errors.cabletype
                          : translate("test_cable_type")}
                      </FormHelperText>
                    </FormControl>

                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.cablepart ? true : false}
                    >
                      <InputLabel htmlFor="cablepart">
                        {translate("test_cable_part_number")}
                      </InputLabel>
                      <Select
                        value={test.cablepart ? test.cablepart.id : ""}
                        onChange={e => this.onChange(e, true)}
                        input={
                          <Input
                            name="cablepart"
                            id="cablepart"
                            value={test.cablepart ? test.cablepart.id : ""}
                          />
                        }
                        fullWidth
                      >
                        {cableparts
                          ? cableparts.map((cabletype, index) => {
                              return (
                                <MenuItem key={index} value={cabletype.id}>
                                  {cabletype.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.cablepart
                          ? errors.cablepart
                          : translate("test_cable_part_number")}
                      </FormHelperText>
                    </FormControl>
                    <TextField
                      error={errors.refractiveindex}
                      required
                      name="refractiveindex"
                      label={translate("test_refractive_index")}
                      margin="normal"
                      fullWidth
                      value={test.refractiveindex}
                      disabled={disableRefractiveIndex}
                      onChange={this.onChange}
                      helperText={
                        errors.refractiveindex
                          ? errors.refractiveindex
                          : translate("test_refractive_index")
                      }
                    />

                    <FormControl
                      margin="normal"
                      fullWidth
                      required
                      error={errors.limitmethodtype ? true : false}
                    >
                      <InputLabel htmlFor="limitmethodtype">
                        {translate("test_loss_budget")}
                      </InputLabel>
                      <Select
                        value={
                          test.limitmethodtype ? test.limitmethodtype.id : ""
                        }
                        onChange={e => this.onChange(e, true)}
                        input={
                          <Input
                            name="limitmethodtype"
                            id="limitmethodtype"
                            value={
                              test.limitmethodtype
                                ? test.limitmethodtype.id
                                : ""
                            }
                            fullWidth
                          />
                        }
                      >
                        {lossBudget
                          ? lossBudget.map((lossbudget, index) => {
                              return (
                                <MenuItem key={index} value={lossbudget.id}>
                                  {lossbudget.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.limitmethodtype
                          ? errors.limitmethodtype
                          : translate("test_loss_budget")}
                      </FormHelperText>
                    </FormControl>
                  </div>
                )}
                {/* {tabPosition === 2 && test.limitmethodtype
                && (test.limitmethodtype.name === 'Cabling Standards' || test.limitmethodtype)
                } */}

                {/* Budget Loss Standard */}
                {tabPosition === 2 &&
                  test.limitmethodtype &&
                  test.limitmethodtype.name === "Cabling Standards" && (
                    <div className={classes.summary}>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.group ? true : false}
                      >
                        <InputLabel htmlFor="group">
                          {translate("test_group")}
                        </InputLabel>
                        <Select
                          value={test.group ? test.group.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="group"
                              id="group"
                              value={test.group ? test.group.id : ""}
                              fullWidth
                            />
                          }
                        >
                          {fiberstdgroups
                            ? fiberstdgroups.map((fiberstd, index) => {
                                return (
                                  <MenuItem key={index} value={fiberstd.id}>
                                    {fiberstd.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.group
                            ? errors.group
                            : translate("test_group")}
                        </FormHelperText>
                      </FormControl>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.standard ? true : false}
                      >
                        <InputLabel htmlFor="standard">
                          {translate("test_standards")}
                        </InputLabel>
                        <Select
                          value={test.standard ? test.standard.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="standard"
                              id="standard"
                              value={test.standard ? test.standard.id : ""}
                              fullWidth
                            />
                          }
                        >
                          {stdDetails
                            ? stdDetails.map((stdDetail, index) => {
                                return (
                                  <MenuItem key={index} value={stdDetail.id}>
                                    {stdDetail.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.standard
                            ? errors.standard
                            : translate("test_standards")}
                        </FormHelperText>
                      </FormControl>
                      {testCordTypeField(this.onChange)}                      
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.adapterscount}
                            required
                            name="adapterscount"
                            label={translate("test_no_of_adapters")}
                            margin="normal"
                            fullWidth
                            value={test.adapterscount}
                            onChange={this.onChange}
                            helperText={
                              errors.adapterscount
                                ? errors.adapterscount
                                : translate("test_no_of_adapters")
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.splicecount}
                            required
                            name="splicecount"
                            label={translate("test_no_of_splices")}
                            margin="normal"
                            fullWidth
                            value={test.splicecount}
                            onChange={this.onChange}
                            helperText={
                              errors.splicecount
                                ? errors.splicecount
                                : translate("test_no_of_splices")
                            }
                          />
                        </Grid>
                      </Grid>

                      <TextField
                        error={errors.maxlength}
                        required
                        name="maxlength"
                        label={
                          lengthMeasurementUnit != "feet"
                            ? translate("test_max_length")
                            : translate("test_max_length_feet")
                        }
                        margin="normal"
                        fullWidth
                        value={test.maxlength}
                        onChange={this.onChange}
                        helperText={
                          errors.maxlength
                            ? errors.maxlength
                            : lengthMeasurementUnit != "feet"
                            ? translate("test_max_length")
                            : translate("test_max_length_feet")
                        }
                        disabled
                      />
                    </div>
                  )}
                {/* Budget Loss Application */}
                {tabPosition === 2 &&
                  test.limitmethodtype &&
                  test.limitmethodtype.name === "Applications" && (
                    <div className={classes.summary}>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.group ? true : false}
                      >
                        <InputLabel htmlFor="group">
                          {translate("test_group")}
                        </InputLabel>
                        <Select
                          value={test.group ? test.group.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="group"
                              id="group"
                              value={test.group ? test.group.id : ""}
                              fullWidth
                            />
                          }
                        >
                          {fiberappgroups
                            ? fiberappgroups.map((fiberappgroup, index) => {
                                return (
                                  <MenuItem
                                    key={index}
                                    value={fiberappgroup.id}
                                  >
                                    {fiberappgroup.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.group
                            ? errors.group
                            : translate("test_group")}
                        </FormHelperText>
                      </FormControl>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.application ? true : false}
                      >
                        <InputLabel htmlFor="application">
                          {translate("test_application")}
                        </InputLabel>
                        <Select
                          value={test.application ? test.application.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="application"
                              id="application"
                              value={
                                test.application ? test.application.id : ""
                              }
                              fullWidth
                            />
                          }
                        >
                          {appDetails
                            ? appDetails.map((appDetail, index) => {
                                return (
                                  <MenuItem key={index} value={appDetail.id}>
                                    {appDetail.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.application
                            ? errors.application
                            : translate("test_application")}
                        </FormHelperText>
                      </FormControl>
                      <Grid container>
                        <Grid item xs={12} sm={12} className={classes.addField}>
                          <span>
                            {translate("test_loss_budget")} ({translate("dB")})
                            *
                          </span>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.halfField}>
                            <p>{this.budgetLossMin}:</p>
                            <TextField
                              error={errors.illosswllow}
                              required
                              name="illosswllow"
                              label=""
                              margin="normal"
                              fullWidth
                              value={test.illosswllow}
                              onChange={this.onChange}
                              disabled
                              helperText={
                                errors.illosswllow ? errors.illosswllow : ""
                              }
                            />
                          </div>
                          <div className={classes.halfField}>
                            <p>{this.budgetLossMax}:</p>
                            <TextField
                              error={errors.illosswlhigh}
                              required
                              name="illosswlhigh"
                              label=""
                              margin="normal"
                              fullWidth
                              value={test.illosswlhigh}
                              onChange={this.onChange}
                              disabled
                              helperText={
                                errors.illosswlhigh ? errors.illosswlhigh : ""
                              }
                            />
                          </div>
                        </Grid>
                      </Grid>
                      <TextField
                        error={errors.maxlength}
                        required
                        name="maxlength"
                        label={
                          lengthMeasurementUnit != "feet"
                            ? translate("test_max_length")
                            : translate("test_max_length_feet")
                        }
                        margin="normal"
                        fullWidth
                        value={test.maxlength}
                        onChange={this.onChange}
                        helperText={
                          errors.maxlength
                            ? errors.maxlength
                            : lengthMeasurementUnit != "feet"
                            ? translate("test_max_length")
                            : translate("test_max_length_feet")
                        }
                        disabled
                      />
                    </div>
                  )}
                {/* Budget Loss MANUAL*/}
                {tabPosition === 2 &&
                  test.limitmethodtype &&
                  test.limitmethodtype.name === "Manual Loss Budget" && (
                    <div className={classes.summary}>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.limitwavelength ? true : false}
                      >
                        <InputLabel htmlFor="limitwavelength">
                          {translate("test_wave_length")}
                        </InputLabel>
                        <Select
                          value={
                            test.limitwavelength ? test.limitwavelength.id : ""
                          }
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="limitwavelength"
                              id="limitwavelength"
                              value={
                                test.limitwavelength
                                  ? test.limitwavelength.id
                                  : ""
                              }
                              fullWidth
                            />
                          }
                        >
                          {wavelengths
                            ? wavelengths.map((wl, index) => {
                                return (
                                  <MenuItem key={index} value={wl.id}>
                                    {wl.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.limitwavelength
                            ? errors.limitwavelength
                            : translate("test_wave_length")}
                        </FormHelperText>
                      </FormControl>
                      <Grid container>
                        <Grid item xs={12} sm={12} className={classes.addField}>
                          <span>
                            {translate("test_loss_budget")} ({translate("dB")})
                            *
                          </span>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.halfField}>
                            <p>{this.budgetLossMin}:</p>
                            <TextField
                              error={errors.illosswllow}
                              required
                              name="illosswllow"
                              label=""
                              margin="normal"
                              fullWidth
                              value={test.illosswllow}
                              onChange={this.onChange}
                              helperText={
                                errors.illosswllow ? errors.illosswllow : ""
                              }
                              disabled={disbleBudgetLossMin}
                            />
                          </div>
                          <div className={classes.halfField}>
                            <p>{this.budgetLossMax}:</p>
                            <TextField
                              error={errors.illosswlhigh}
                              required
                              name="illosswlhigh"
                              label=""
                              margin="normal"
                              fullWidth
                              value={test.illosswlhigh}
                              onChange={this.onChange}
                              helperText={
                                errors.illosswlhigh ? errors.illosswlhigh : ""
                              }
                              disabled={disbleBudgetLossMax}
                            />
                          </div>
                        </Grid>
                      </Grid>
                      {/* Length */}
                      <Grid container>
                        <Grid item xs={12} sm={12} className={classes.addField}>
                          <span>{translate("test_length")}</span>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={test.measurelength}
                                onChange={this.onLenghtLimitChange}
                                value={test.measurelength}
                                name={"measurelength"}
                              />
                            }
                            label={translate("use_length_from_the_results")}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={test.callimitlength}
                                onChange={this.onLenghtLimitChange}
                                value={test.callimitlength}
                                name={"callimitlength"}
                              />
                            }
                            label={translate(
                              "apply_length_limit_to_the_test_results"
                            )}
                            disabled={allowApplyLength}
                          />
                        </Grid>
                      </Grid>

                      <TextField
                        error={errors.maxlength}
                        required
                        name="maxlength"
                        label={
                          lengthMeasurementUnit != "feet"
                            ? translate("test_length_limit")
                            : translate("test_length_limit_feet")
                        }
                        margin="normal"
                        fullWidth
                        value={test.maxlength}
                        onChange={this.onChange}
                        helperText={
                          errors.maxlength
                            ? errors.maxlength
                            : lengthMeasurementUnit != "feet"
                            ? translate("test_length_limit")
                            : translate("test_length_limit_feet")
                        }
                        disabled={allowEditMaxLength}
                      />
                    </div>
                  )}

                {/* Budget Loss calculator */}
                {tabPosition === 2 &&
                  test.limitmethodtype &&
                  test.limitmethodtype.name === "Loss Budget Calculator" && (
                    <div className={classes.summary}>
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            margin="normal"
                            required
                            error={errors.limitwavelength ? true : false}
                          >
                            <InputLabel htmlFor="limitwavelength">
                              {translate("test_wave_length")}
                            </InputLabel>
                            <Select
                              value={
                                test.limitwavelength
                                  ? test.limitwavelength.id
                                  : ""
                              }
                              onChange={e => this.onChange(e, true)}
                              input={
                                <Input
                                  name="limitwavelength"
                                  id="limitwavelength"
                                  value={
                                    test.limitwavelength
                                      ? test.limitwavelength.id
                                      : ""
                                  }
                                  fullWidth
                                />
                              }
                            >
                              {wavelengths
                                ? wavelengths.map((wl, index) => {
                                    return (
                                      <MenuItem key={index} value={wl.id}>
                                        {wl.name}
                                      </MenuItem>
                                    );
                                  })
                                : null}
                            </Select>
                            <FormHelperText>
                              {errors.limitwavelength
                                ? errors.limitwavelength
                                : translate("test_wave_length")}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {testCordTypeField(this.onChange)}                         
                        </Grid>
                      </Grid>

                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            component="fieldset"
                            required
                            className={classes.formControl}
                            error={errors.cableshielding ? true : false}
                          >
                            <FormLabel component="legend">
                              {translate("test_length")}
                            </FormLabel>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={test.measurelength}
                                  onChange={this.onLenghtLimitChange}
                                  value={test.measurelength}
                                  name={"measurelength"}
                                />
                              }
                              label={translate("use_length_from_the_results")}
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={test.callimitlength}
                                  onChange={this.onLenghtLimitChange}
                                  value={test.callimitlength}
                                  name={"callimitlength"}
                                />
                              }
                              label={translate(
                                "apply_length_limit_to_the_test_results"
                              )}
                              disabled={allowApplyLength}
                            />
                            <TextField
                              error={errors.maxlength}
                              required
                              name="maxlength"
                              label={
                                lengthMeasurementUnit != "feet"
                                  ? translate("test_length_limit")
                                  : translate("test_length_limit_feet")
                              }
                              margin="normal"
                              fullWidth
                              value={test.maxlength}
                              onChange={this.onChange}
                              disabled={allowEditMaxLength}
                              helperText={
                                errors.maxlength
                                  ? errors.maxlength
                                  : lengthMeasurementUnit != "feet"
                                  ? translate("test_length_limit")
                                  : translate("test_length_limit_feet")
                              }
                            />
                          </FormControl>
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              className={classes.addField}
                            >
                              <span>
                                {translate("test_loss_budget")}{" "}
                                {translate("loss_budget_unit")} *
                              </span>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <div className={classes.halfField}>
                                <p>{this.budgetLossMin}:</p>
                                <TextField
                                  error={errors.illosswllow}
                                  required
                                  name="illosswllow"
                                  label=""
                                  margin="normal"
                                  fullWidth
                                  value={test.illosswllow}
                                  onChange={this.onChange}
                                  helperText={
                                    errors.illosswllow ? errors.illosswllow : ""
                                  }
                                  disabled={disbleBudgetLossMin}
                                />
                              </div>
                              <div className={classes.halfField}>
                                <p>{this.budgetLossMax}:</p>
                                <TextField
                                  error={errors.illosswlhigh}
                                  required
                                  name="illosswlhigh"
                                  label=""
                                  margin="normal"
                                  fullWidth
                                  value={test.illosswlhigh}
                                  onChange={this.onChange}
                                  helperText={
                                    errors.illosswlhigh
                                      ? errors.illosswlhigh
                                      : ""
                                  }
                                  disabled={disbleBudgetLossMax}
                                />
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.splicecount}
                            required
                            name="splicecount"
                            label={translate("test_no_of_splices")}
                            margin="normal"
                            fullWidth
                            value={test.splicecount}
                            onChange={this.onChange}
                            helperText={
                              errors.splicecount
                                ? errors.splicecount
                                : translate("test_no_of_splices")
                            }
                          />
                          <TextField
                            error={errors.spliceloss}
                            required
                            name="spliceloss"
                            label={translate("test_splice_loss_value")}
                            margin="normal"
                            fullWidth
                            value={test.spliceloss}
                            onChange={this.onChange}
                            helperText={
                              errors.spliceloss
                                ? errors.spliceloss
                                : translate("test_splice_loss_value")
                            }
                          />
                          <TextField
                            error={errors.adapterscount}
                            required
                            name="adapterscount"
                            label={translate("test_no_of_adapters")}
                            margin="normal"
                            fullWidth
                            value={test.adapterscount}
                            onChange={this.onChange}
                            helperText={
                              errors.adapterscount
                                ? errors.adapterscount
                                : translate("test_no_of_adapters")
                            }
                          />
                          <TextField
                            error={errors.adapterloss}
                            required
                            name="adapterloss"
                            label={translate("test_adapter_loss_value")}
                            margin="normal"
                            fullWidth
                            value={test.adapterloss}
                            onChange={this.onChange}
                            helperText={
                              errors.adapterloss
                                ? errors.adapterloss
                                : translate("test_adapter_loss_value")
                            }
                          />
                        </Grid>
                      </Grid>
                    </div>
                  )}

                {tabPosition === 3 && (
                  <div className={classes.summary}>
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.testmode ? true : false}
                    >
                      <InputLabel htmlFor="testmode">
                        {translate("test_mode")}
                      </InputLabel>
                      <Select
                        value={test.testmode ? test.testmode.id : ""}
                        onChange={e => this.onChange(e, true)}
                        input={
                          <Input
                            name="testmode"
                            id="testmode"
                            value={test.testmode ? test.testmode.id : ""}
                          />
                        }
                        fullWidth
                      >
                        {testmode
                          ? testmode.map((mode, index) => {
                              return (
                                <MenuItem key={index} value={mode.id}>
                                  {mode.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.testmode
                          ? errors.testmode
                          : translate("test_mode")}
                      </FormHelperText>
                    </FormControl>
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.direction ? true : false}
                    >
                      <InputLabel htmlFor="direction">
                        {translate("test_direction")}
                      </InputLabel>
                      <Select
                        value={test.direction ? test.direction.id : ""}
                        onChange={e => this.onChange(e, true)}
                        input={
                          <Input
                            name="direction"
                            id="direction"
                            value={test.direction ? test.direction.id : ""}
                          />
                        }
                        fullWidth
                      >
                        {direction
                          ? direction.map((dir, index) => {
                              return (
                                <MenuItem key={index} value={dir.id}>
                                  {dir.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.direction
                          ? errors.direction
                          : translate("test_direction")}
                      </FormHelperText>
                    </FormControl>
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.referencemethod ? true : false}
                    >
                      <InputLabel htmlFor="referencemethod">
                        {translate("test_cord_reference")}
                      </InputLabel>
                      <Select
                        value={
                          test.referencemethod ? test.referencemethod.id : ""
                        }
                        onChange={e => this.onChange(e, true)}
                        input={
                          <Input
                            name="referencemethod"
                            id="referencemethod"
                            value={
                              test.referencemethod
                                ? test.referencemethod.id
                                : ""
                            }
                          />
                        }
                        fullWidth
                      >
                        {testcordreference
                          ? testcordreference.map((cord, index) => {
                              return (
                                <MenuItem key={index} value={cord.id}>
                                  {cord.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.referencemethod
                          ? errors.referencemethod
                          : translate("test_cord_reference")}
                      </FormHelperText>
                    </FormControl>

                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.flux ? true : false}
                    >
                      <InputLabel htmlFor="flux">
                        {translate("test_encircled_flux")}
                      </InputLabel>
                      <Select
                        value={test.flux ? test.flux : false}
                        onChange={e => this.onChange(e)}
                        input={
                          <Input
                            name="flux"
                            id="flux"
                            value={test.flux ? test.flux : false}
                          />
                        }
                        fullWidth
                      >
                        {boolValue.map((bool, index) => {
                          return (
                            <MenuItem key={index} value={bool.id}>
                              {bool.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <FormHelperText>
                        {errors.flux
                          ? errors.flux
                          : translate("test_encircled_flux")}
                      </FormHelperText>
                    </FormControl>
                    <FormControl
                      className={classes.textField}
                      margin="normal"
                      required
                      error={errors.connectortype ? true : false}
                    >
                      <InputLabel htmlFor="connectortype">
                        {translate("test_connector_type")}
                      </InputLabel>
                      <Select
                        value={test.connectortype ? test.connectortype.id : ""}
                        onChange={e => this.onChange(e, true)}
                        input={
                          <Input
                            name="connectortype"
                            id="connectortype"
                            value={
                              test.connectortype ? test.connectortype.id : ""
                            }
                          />
                        }
                        fullWidth
                      >
                        {connectortype
                          ? connectortype.map((connector, index) => {
                              return (
                                <MenuItem key={index} value={connector.id}>
                                  {connector.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </Select>
                      <FormHelperText>
                        {errors.connectortype
                          ? errors.connectortype
                          : translate("test_connector_type")}
                      </FormHelperText>
                    </FormControl>
                  </div>
                )}

                {tabPosition === 4 && (
                  <div className={classes.summary}>
                    {showAllMetadataSwitch && (
                      <Typography type="subheading">
                        <FormControlLabel
                          control={
                            <Switch
                              name="allmetadataoptions"
                              checked={test.allmetadataoptions}
                              onChange={(e, checked) =>
                                this.onToggleChange(e, checked)
                              }
                              disabled={disabledToogleIdentifier}
                            />
                          }
                          label={translate("test_add_metadata_item")}
                        />
                      </Typography>
                    )}

                    {custom &&
                      custom
                        .sort((a, b) => {
                          return a.level > b.level
                            ? -1
                            : a.level < b.level
                            ? 1
                            : 0;
                        })
                        .map((c, index) => {
                          metadataOption = test.metadata.find(
                            x => parseInt(x.level, 10) === parseInt(c.level, 10)
                          );
                          return (test.allmetadataoptions ||
                            metadataOption.default ||
                            metadataOption.enabled) &&
                            c.level !== 1 ? (
                            <div key={index}>
                              <Checkbox
                                name={c.level}
                                checked={metadataOption.enabled}
                                onChange={this.onCustomCheckChange}
                              />
                              <select
                                name={c.level}
                                value={metadataOption.field}
                                onChange={this.onCustomChange}
                                disabled={!metadataOption.enabled}
                              >
                                {c.values.map((o, index) => {
                                  return (
                                    <option key={index} value={o.id}>
                                      {o.name}
                                    </option>
                                  );
                                })}
                              </select>
                              <TextField
                                error={errors[c.level] ? true : false}
                                required
                                name={c.level}
                                margin="normal"
                                value={metadataOption.value}
                                onChange={this.onChangeMetadataField}
                                disabled={!metadataOption.enabled}
                              />
                            </div>
                          ) : null;
                        })}
                  </div>
                )}
              </form>
            </ModalContents>

            <ModalFooter>
              <Button
                raised
                className={classes.button}
                onClick={() => this.tabBack()}
                disabled={!this.canTabBack().can ? true : false}
              >
                <Icon>navigate_before</Icon>
              </Button>

              <Button
                raised
                className={classes.button}
                onClick={() => this.tabNext()}
                disabled={!this.canTabNext().can ? true : false}
              >
                <Icon>navigate_next</Icon>
              </Button>

              {this.tabsComplete() ? (
                <Button
                  raised
                  color="accent"
                  className={classes.submit}
                  onClick={() => this.createTests()}
                  type="submit"
                  disabled={
                    testIDType === "import" && Object.keys(IDerrors).length != 0
                  }
                >
                  {translate("test_create")}
                </Button>
              ) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }

  componentWillReceiveProps(nextProps) {
    const { testNameList, IDerrors } = nextProps;
    let test = { ...this.state.test };
    if (this.props.testNameList !== testNameList) {
      test.names = testNameList;
      this.setState({
        test
      });
    }
    // if (this.props.IDerrors !== IDerrors) {
    //   var tempIDErrors = IDerrors == null ? {} : IDerrors;
    //   this.setState({
    //     IDerrors: tempIDErrors
    //   });
    // }
  }

  componentDidMount() {
    const { test } = this.state;
    const { userPreference } = this.props;
    const disabledToogleIdentifier = test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    this.setState({
      disabledToogleIdentifier
    });
    var isUserPreferenceSaved = false;
    userPreference &&
      userPreference.metadata.map(x => {
        if (x.value != null) isUserPreferenceSaved = true;
      });
    if (isUserPreferenceSaved == true) {
      this.checkForAlreadySelectedSubtests(
        this.state.test,
        this.props.type == "copper" ? "true" : "false"
      );
    }

    if (!this.props.modalState) {
      this.setFiberStandards({ ...test });
    }
  }

  setFiberStandards = test => {
    const { standards, fiberStandards, lengthMeasurementUnit } = this.props;
    if (!fiberStandards) {
      return;
    }
    let lossBudget,
      fiberappgroups,
      cablebrands,
      fiberstdgroups,
      testmode,
      direction,
      testcordreference,
      connectortype,
      wavelengthdetails,
      cordtypes,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      allowApplyLength,
      allowEditMaxLength,
      multiCordTypes;

    if (fiberStandards) {
      fiberappgroups = fiberStandards.appgroups;
      cablebrands = fiberStandards.cablebrands;
      fiberstdgroups = fiberStandards.stdgroups;
      lossBudget = fiberStandards.lossbudget;
      testmode = fiberStandards.testmode;
      direction = fiberStandards.direction;
      testcordreference = fiberStandards.testcordreference;
      connectortype = fiberStandards.connectortype;
      wavelengthdetails = fiberStandards.wavelengthdetails;
      cordtypes = fiberStandards.testcordtypes;
      multiCordTypes = fiberStandards.refCordLossList;
    }

    const testmodevalue =
      test.testmode && testmode
        ? testmode.find(o => o.id == test.testmode.id)
        : testmode.find(o => o.id == 0);
    const directionvalue =
      test.direction && direction
        ? direction.find(o => o.id == test.direction.id)
        : direction.find(o => o.id == 0);
    const referencemethodvalue =
      test.testcordreference && testcordreference
        ? testcordreference.find(o => o.id == test.testcordreference.id)
        : testcordreference.find(o => o.id == 0);
    const limitmethodtypevalue =
      test.limitmethodtype && lossBudget
        ? lossBudget.find(o => o.id == test.limitmethodtype.id)
        : lossBudget.find(o => o.id == 0);
    let cabletypes =
      test.cablebrand && cablebrands
        ? cablebrands.find(x => x.id === test.cablebrand.id)
        : null;
    cabletypes =
      cabletypes && cabletypes.cabletypedetails
        ? cabletypes.cabletypedetails
        : null;
    let cableparts =
      test.cabletype && cabletypes
        ? cabletypes.find(x => x.id === test.cabletype.id)
        : null;
    this.cableType = cableparts ? cableparts.type : null;
    cableparts =
      cableparts && cableparts.cablepartdetails
        ? cableparts.cablepartdetails
        : null;
    test.flux = test.flux ? test.flux : false;

    let appDetails = [];
    let stdDetails = [];

    // filter groups based on cabletypeName when limit method type is cabling standard
    if (
      test.limitmethodtype &&
      test.cabletype &&
      test.limitmethodtype.name == "Cabling Standards"
    ) {
      fiberstdgroups = fiberstdgroups.filter(standardDetailsObj => {
        let o = standardDetailsObj.standarddetails.filter(obj => {
          let m = obj.lengthdetails.filter(
            o =>
              o.name === test.cabletype.name &&
              (o.length != null ||
                o.lossbudgetlow != null ||
                o.lossbudgethigh != null)
          );
          if (m.length) {
            return true;
          } else {
            return false;
          }
        });
        if (o.length) {
          return true;
        } else {
          return false;
        }
      });

      if (test.group) {
        let standarddDetails = fiberstdgroups
          ? fiberstdgroups.find(x => x.id === test.group.id)
          : null;
        // filter standards based on cabletypeName
        if (
          standarddDetails &&
          standarddDetails.standarddetails &&
          test.cabletype.name
        ) {
          standarddDetails = standarddDetails.standarddetails.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          stdDetails = standarddDetails ? standarddDetails : [];
        }
      }
    }

    // filter groups based on cabletypeName when limit method type is application
    if (
      test.limitmethodtype &&
      test.cabletype &&
      test.limitmethodtype.name == "Applications"
    ) {
      fiberappgroups = fiberappgroups.filter(applicationDetailsObj => {
        let o = applicationDetailsObj.applications.filter(obj => {
          let m = obj.lengthdetails.filter(
            o =>
              o.name === test.cabletype.name &&
              (o.length != null ||
                o.lossbudgetlow != null ||
                o.lossbudgethigh != null)
          );
          if (m.length) {
            return true;
          } else {
            return false;
          }
        });
        if (o.length) {
          return true;
        } else {
          return false;
        }
      });

      if (test.group) {
        let applicationDetails = fiberappgroups
          ? fiberappgroups.find(x => x.id === test.group.id)
          : null;
        // filter applications based on cabletypeName
        if (
          applicationDetails &&
          applicationDetails.applications &&
          test.cabletype.name
        ) {
          applicationDetails = applicationDetails.applications.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          appDetails = applicationDetails ? applicationDetails : [];
        }
      }
    }

    let connectortypevalue =
      test.connectortype && connectortype
        ? connectortype.find(x => x.id === test.connectortype.id)
        : connectortype.find(o => o.id === 1);
    allowEditMaxLength = !test.measurelength;
    allowApplyLength = !test.callimitlength;
    let wavelengths = wavelengthdetails
      ? wavelengthdetails.find(x => x.cabletype === this.cableType)
      : null;
    if (wavelengths && wavelengths.wavelengthvalue) {
      let waveLengthValue = wavelengths.wavelengthvalue;
      this.budgetLossMin = waveLengthValue[0];
      this.budgetLossMax = waveLengthValue[1];
    }
    wavelengths =
      wavelengths && wavelengths.wavelength ? wavelengths.wavelength : null;
    if (test.limitwavelength) {
      if (test.limitwavelength.id === 0) {
        disbleBudgetLossMin = false;
        disbleBudgetLossMax = true;
      } else if (test.limitwavelength.id === 1) {
        disbleBudgetLossMin = true;
        disbleBudgetLossMax = false;
      } else {
        disbleBudgetLossMin = false;
        disbleBudgetLossMax = false;
      }
    }
    let isConvertedToFeet = false;
    if (!this.state.isConvertedToFeet) {
      test.maxlength =
        lengthMeasurementUnit == "feet"
          ? Math.round((test.maxlength / 0.3048) * 100) / 100
          : test.maxlength;
      isConvertedToFeet = true;
    }
    this.setState({
      lossBudget,
      fiberappgroups,
      cablebrands,
      fiberstdgroups,
      testmode,
      direction,
      testcordreference,
      connectortype,
      wavelengthdetails,
      cordtypes,
      multiCordTypes,
      cabletypes,
      cableparts,
      appDetails: appDetails || [],
      stdDetails: stdDetails || [],
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      disableRefractiveIndex:
        test &&
        test.cablebrand &&
        test.cablebrand.name.toLowerCase().includes("generic")
          ? false
          : true,
      allowEditMaxLength,
      allowApplyLength,
      wavelengths,
      test: {
        ...test,
        testmode: testmodevalue,
        direction: directionvalue,
        referencemethod: referencemethodvalue,
        limitmethodtype: limitmethodtypevalue,
        connectortype: connectortypevalue
      },
      isConvertedToFeet
    });
  };

  componentWillMount() {
    if (this.props.modalState) {
      this.setFiberStandards({ ...this.props.modalState });
    }
  }
}

export default withStyles(styles)(CreateFiberTest);



// WEBPACK FOOTER //
// ./src/components/job/newfiber/index.js